import * as React from 'react';

import { DropdownInput, } from '../../../../Shared/index';
import DemoGuardedButton from '../../shared/demoGuardedButton';

const AccessibilitySettings = ({ activateSection, active, deactivateSection, passedSnackbarDuration, updateAccessibilitySettings, }) => {
  const [snackbarDuration, setSnackbarDuration] = React.useState(passedSnackbarDuration)

  React.useEffect(() => {
    if (active) { return }

    reset()
  }, [active])

  React.useEffect(() => {
    if (snackbarDuration !== passedSnackbarDuration) {
      activateSection()
    }
  }, [snackbarDuration])

  function handleDropdownChange(option) { setSnackbarDuration(option.value) }

  function reset() {
    setSnackbarDuration(passedSnackbarDuration)
  }

  function resetAndDeactivateSection() {
    reset()
    deactivateSection()
  }

  function handleSubmit(e) {
    e?.preventDefault()
    const data = {
      accessibility_setting: {
        snackbar_duration: snackbarDuration,
      },
    };
    updateAccessibilitySettings(data, 'Settings saved')
  }

  function renderButtonSection() {
    if (!active) { return }

    const submitButtonClassName = "quill-button contained medium green focus-on-light"

    let submitButton = <input aria-label="Save changes" className={`${submitButtonClassName} disabled`} disabled type="submit" value="Save changes" />

    if (snackbarDuration) {
      submitButton = <DemoGuardedButton className={submitButtonClassName} onClick={handleSubmit}>Save changes</DemoGuardedButton>
    }

    return (
      <div className="button-section">
        <button className="quill-button outlined medium grey focus-on-light" id="cancel" onClick={resetAndDeactivateSection} type="button">Cancel</button>
        {submitButton}
      </div>
    )
  }

  const options = [
    { label: '7 seconds', value: 7000, },
    { label: '10 seconds', value: 10000, },
    { label: '30 seconds', value: 30000, },
    { label: '1 minute', value: 60000, },
    { label: '2 minutes', value: 120000, },
  ]

  return (
    <section aria-labelledby="accessibilitySettingsTitle" className="user-account-section accessibility-section">
      <h1 id="accessibilitySettingsTitle">Accessibility Settings</h1>
      <form acceptCharset="UTF-8" onSubmit={handleSubmit} >
        <div className="fields" onClick={activateSection}>
          <DropdownInput
            className="bordered small focus-on-light"
            handleChange={handleDropdownChange}
            label="How long should in-app notification messages stay on screen?"
            options={options}
            value={options.find(opt => opt.value === snackbarDuration)}
          />
        </div>
      </form>
      {renderButtonSection()}
    </section>
  )
}

export default AccessibilitySettings
